export enum TableRenderMode {
    PERFORMANCE = 'performance',
    STANDARD = 'standard'
}

export enum RenderModeOption {
    AUTO = 'auto',
    PERFORMANCE = 'performance',
    STANDARD = 'standard'
}

export enum PreferencesSections {
    PRESETS             = 'presets',
    DISPLAY_SETTINGS    = 'display-settings',
    COLOR_CODING        = 'color-coding',
    COLUMNS             = 'columns',
}